import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = "Ryan Putman's Portfolio";
}



// WEBPACK FOOTER //
// /Users/Putman/Desktop/Javascript Projects/angular-portfolio/src/app/app.component.ts